module.exports = __webpack_public_path__ + "static/media/OCFL-News-Page-Needs-2.6cef53b7.png";